<template>
  <div class="">
    <main class="l-content">
      <div class="l-section wpb_row height_small mpc-row">
        <div class="l-section-h">
          <div class="svg-list">
            <div v-for="(item, index) in svgArr" :key="index" class="svg-list__item">
              <BaseSvg :name="item" />
              <span class="svg-list__label">{{ item }}</span>
            </div>
          </div>
          <hr />
          <div class="buttons">
            <a href="#" class="base-btn _disabled">Детальніше</a>
            <a href="#" class="base-btn">Детальніше</a>
            <a href="#" class="base-btn _black">Детальніше</a>
          </div>
          <hr />
          <h1>Title h1</h1>
          <p>
            Lorem ipsum dolor sit amet, <a href="#">consectetur adipisicing elit</a>. Ab aliquam
            aliquid esse iste magnam minima nemo nobis, sequi soluta totam. Accusantium animi beatae
            hic ipsa perspiciatis praesentium similique ullam unde.
          </p>
          <h2>Title h2</h2>
          <p>
            Lorem ipsum dolor sit amet, <a href="#">consectetur adipisicing elit</a>. Ab aliquam
            aliquid esse iste magnam minima nemo nobis, sequi soluta totam. Accusantium animi beatae
            hic ipsa perspiciatis praesentium similique ullam unde.
          </p>
          <h3>Title h3</h3>
          <p>
            Lorem ipsum dolor sit amet, <a href="#">consectetur adipisicing elit</a>. Ab aliquam
            aliquid esse iste magnam minima nemo nobis, sequi soluta totam. Accusantium animi beatae
            hic ipsa perspiciatis praesentium similique ullam unde.
          </p>
          <h4>Title h4</h4>
          <p>
            Lorem ipsum dolor sit amet, <a href="#">consectetur adipisicing elit</a>. Ab aliquam
            aliquid esse iste magnam minima nemo nobis, sequi soluta totam. Accusantium animi beatae
            hic ipsa perspiciatis praesentium similique ullam unde.
          </p>
        </div>
        <div v-for="(item, index) in translates" :key="index">{{ $t(item.slice(4, -2)) }}</div>
      </div>
    </main>
  </div>
</template>

<script>
const translatesJson = {
  1: '$t("Ви бажаєте дізнаватися про акції та пропозиції від закладу?")',
  2: '$t("Приєднатися до нас")',
  3: '$t("Сім’я ресторанів «Classic»")',
  4: '$t("Доставка")',
  5: '$t("Показати більше")',
  6: '$t("Контакти")',
  7: '$t("Заповніть всі обовязкові поля")',
  8: '$t("Обов\'язкове поле")',
  9: '$t("Категорій не знайдено")',
  10: '$t("Товарів не знайдено")',
  11: '$t("Показати більше")',
  12: '$t("грн")',
  13: '$t("Зібрати піцу")',
  14: '$t("Замовити")',
  15: '$t("Замовити")',
  16: '$t("На головну")',
  17: '$t("Сторінку не знайдено. Неправильно набрано адресу або такої сторінки на сайті більше не існує")',
  18: '$t("Розмір")',
  19: '$t("Варіант")',
  20: '$t("Соус")',
  21: '$t("Додаткові інгредієнти")',
  22: '$t("Всього")',
  23: '$t("грн")',
  24: '$t("Замовити")',
  25: '$t("В кошик")',
  26: '$t("Ваш коментар")',
  27: '$t("Додати коментар")',
  28: '$t("грн")',
  29: '$t("Основні інгредієнти")',
  30: '$t("Додаткові інгредієнти")',
  31: '$t("вибрано")',
  32: '$t("Важливо! Основні інгредієнти (5 шт.) вже включені у вартість піци. Решта інгредієнтів (якщо такі будуть вибрані) оплачуються додатково. Під одним інгредієнтом слід розуміти одну порцію інгредієнта.")',
  33: '$t("грн")',
  34: '$t("Розмір")',
  35: '$t("Варіант")',
  36: '$t("Соус")',
  37: '$t("Основні інгредієнти")',
  38: '$t("Додаткові інгредієнти")',
  39: '$t("Всього")',
  40: '$t("грн")',
  41: '$t("Замовити")',
  42: '$t("В кошик")',
  43: '$t("Ваш коментар")',
  44: '$t("Додати коментар")',
  45: '$t("Введіть новий пароль")',
  46: '$t("Пароль")',
  47: '$t("Повторіть пароль")',
  48: '$t("Змінити пароль")',
  49: '$t("Вхід")',
  50: '$t("Оформлення замовлення")',
  51: '$t("Товар")',
  52: '$t("Загалом")',
  53: '$t("Товари")',
  54: '$t("грн")',
  55: '$t("Пакування")',
  56: '$t("грн")',
  57: '$t("Доставка")',
  58: '$t("грн")',
  59: '$t("Знижка")',
  60: '$t("грн")',
  61: '$t("Разом до оплати")',
  62: '$t("грн")',
  63: '$t("Деталі")',
  64: '$t("Не дзвонити в двері")',
  65: '$t("У мене мала дитина (до 12 років)")',
  66: '$t("У мене є собака")',
  67: '$t("Оформити замовлення")',
  68: '$t("Кошик порожній")',
  69: '$t("Ви нічого не додали у кошик, перейдіть у розділ доставки")',
  70: '$t("Доставка")',
  71: '$t("грн")',
  72: '$t("Пакування")',
  73: '$t("грн")',
  74: '$t("Загалом")',
  75: '$t("грн")',
  76: '$t("Розмір")',
  77: '$t("Варіант")',
  78: '$t("Соус")',
  79: '$t("Основні інгредієнти")',
  80: '$t("Додаткові інгредієнти")',
  81: '$t("Коментар")',
  82: '$t("Контактні дані")',
  83: '$t("Ім\'я")',
  84: '$t("Телефон")',
  85: '$t("Спосіб доставки")',
  86: '$t("Місто / населений пункт")',
  87: '$t("Вулиця")',
  88: '$t("Під\'їзд")',
  89: '$t("№ будинку")',
  90: '$t("№ квартири")',
  91: '$t("Час доставки")',
  92: '$t("Побажання до замовлення")',
  93: '$t("Оберіть заклад")',
  94: '$t("Час приготування")',
  95: '$t("Побажання до замовлення")',
  96: '$t("Cпосіб оплати")',
  97: '$t("Увага!")',
  98: '$t("Мінімальна сума замовлення для Вашого населеного пункту становить")',
  99: '$t("грн")',
  100: '$t("Оформлення замовлення")',
  101: '$t("Ви бажаєте дізнаватися про акції та пропозиції від закладу?")',
  102: '$t("Приєднатися до нас")',
  103: '$t("Сім’я ресторанів «Classic»")',
  104: '$t("Доставка")',
  105: '$t("Показати більше")',
  106: '$t("Контакти")',
  107: '$t("Категорій не знайдено")',
  108: '$t("Товарів не знайдено")',
  109: '$t("грн")',
  110: '$t("Зібрати піцу")',
  111: '$t("Замовити")',
  112: '$t("На головну")',
  113: '$t("Сторінку не знайдено. Неправильно набрано адресу або такої сторінки на сайті більше не існує")',
  114: '$t("Додати інгредієнти")',
  115: '$t("Всього")',
  116: '$t("В кошик")',
  117: '$t("Додати коментар")',
  118: '$t("Додаткові інгредієнти")',
  119: '$t("не більше")',
  120: '$t("Введіть новий пароль")',
  121: '$t("Пароль")',
  122: '$t("Повторіть пароль")',
  123: '$t("Змінити пароль")',
  124: '$t("Оформлення замовлення")',
  125: '$t("Товар")',
  126: '$t("Загалом")',
  127: '$t("Товари")',
  128: '$t("Пакування")',
  129: '$t("Разом до оплати")',
  130: '$t("Деталі")',
  131: '$t("Не дзвонити в двері")',
  132: '$t("У мене мала дитина (до 12 років)")',
  133: '$t("У мене є собака")',
  134: '$t("Кошик порожній")',
  135: '$t("Ви нічого не додали у кошик, перейдіть у розділ доставки")',
  136: '$t("Оформити замовлення")',
  137: '$t("Розмір")',
  138: '$t("Варіант")',
  139: '$t("Соус")',
  140: '$t("Коментар")',
  141: '$t("Контактні дані")',
  142: '$t("Ім\\\'я")',
  143: '$t("Телефон")',
  144: '$t("Спосіб доставки")',
  145: '$t("Місто / населений пункт")',
  146: '$t("Вулиця")',
  147: '$t("Під\\\'їзд")',
  148: '$t("№ будинку")',
  149: '$t("№ квартири")',
  150: '$t("Час доставки")',
  151: '$t("Побажання до замовлення")',
  152: '$t("Оберіть заклад")',
  153: '$t("Час приготування")',
  154: '$t("Cпосіб оплати")',
  155: '$t("Меню")',
  156: '$t("Кабінет")',
  157: '$t("Вхід")',
  158: '$t("Ресторани")',
  159: '$t("Новини")',
  160: '$t("Вакансії")',
  161: '$t("Адреси у м.Ковель")',
  162: '$t("Сім’я ресторанів «Classic». Всі права застережено!")',
  163: '$t("Розроблено")',
  164: '$t("Забули пароль?")',
  165: '$t("Реєстрація")',
  166: '$t("Зареєструватись")',
  167: '$t("Підписатися")',
  168: '$t("Виберіть один із закладів, які підтримують послугу онлайн замовлення.")',
  169: '$t("Меню")',
  170: '$t("Доставка")',
  171: '$t("грн")',
  172: '$t("Кабінет")',
  173: '$t("Вхід")',
  174: '$t("Доставка")',
  175: '$t("Ресторани")',
  176: '$t("Меню")',
  177: '$t("Новини")',
  178: '$t("Вакансії")',
  179: '$t("Контакти")',
  180: '$t("Адреси у м.Ковель")',
  181: '$t("Сім’я ресторанів «Classic». Всі права застережено!")',
  182: '$t("Розроблено")',
  183: '$t("Телефон")',
  184: '$t("Пароль")',
  185: '$t("Забули пароль?")',
  186: '$t("Вхід")',
  187: '$t("Реєстрація")',
  188: '$t("Телефон")',
  189: '$t("Пароль")',
  190: '$t("Зареєструватись")',
  191: '$t("Змінити пароль")',
  192: '$t("Ім\'я")',
  193: '$t("Підписатися")',
  194: '$t("Виберіть один із закладів, які підтримують послугу онлайн замовлення.")',
  195: '$t("Зателефонувати мені для підтвердження")',
};

export default {
  name: "Guide",
  data() {
    return {
      svgArr: [],
    };
  },
  computed: {
    translates() {
      return JSON.parse(JSON.stringify(translatesJson));
    },
  },
  methods: {
    createTitle() {
      const arr = document.querySelector("#svgList defs").children;
      if (!arr) return;

      for (let item of arr) {
        this.svgArr.push(item.id);
      }
    },
  },
  mounted() {
    this.createTitle();
  },
};
</script>

<style lang="less">
.svg-list {
  &__item {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin: 5px;
    padding: 10px 5px;
    border: 1px solid #999999;
    border-radius: 5px;

    svg {
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
    }
  }

  &__label {
    border-top: 1px solid #999999;
    padding-top: 3px;
    font-size: 12px;
  }
}

.buttons {
  .base-btn {
    margin: 5px;
  }
}
</style>
